import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import View from "./View";
import PageHeader from "../../components/PageHeader";
import SearchIcon from "@material-ui/icons/Search";

import Api from "../../../Api";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const ViewLots = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="View Lots"
    >
      <Container maxWidth="lg">

        <PageHeader
          icon={<SearchIcon />}
          title="View Lots"
          subtitle="Browse and manage auction lots"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>

      </Container>
    </Page>
  );
};

export default ViewLots;